module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', [_c('mu-card-header', {
    staticClass: "headerHasBack",
    attrs: {
      "title": _vm.title,
      "subTitle": _vm.$t('message.foodDiaryLandingExplain'),
      "titleClass": "mediumTitle"
    }
  }, [_c('mu-icon-button', {
    attrs: {
      "slot": "avatar",
      "icon": "arrow_back",
      "mini": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack()
      }
    },
    slot: "avatar"
  })], 1), _vm._v(" "), _c('mu-divider'), _vm._v(" "), _c('mu-content-block', {
    staticStyle: {
      "padding": "16px"
    }
  }, [_c('mu-row', {
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-row', {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-paper', {
    staticClass: "paperCard",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-content-block', {
    staticClass: "landingCard",
    nativeOn: {
      "click": function($event) {
        return _vm.goToSearch.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "58px"
    },
    attrs: {
      "src": "static/food-diary/search.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelBelowImg"
  }, [_vm._v(_vm._s(_vm.$t('message.searchText')))])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "50",
      "tablet": "50",
      "width": "50"
    }
  }, [_c('mu-paper', {
    staticClass: "paperCard",
    attrs: {
      "align": "center"
    }
  }, [_c('mu-content-block', {
    staticClass: "landingCard",
    nativeOn: {
      "click": function($event) {
        return _vm.goToMyMeals.apply(null, arguments)
      }
    }
  }, [_c('mu-flexbox', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "58px"
    },
    attrs: {
      "src": "static/food-diary/baseline-restaurant_menu-24px.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "labelBelowImg"
  }, [_vm._v(_vm._s(_vm.$t('message.foodDiaryLoadFromMyMeals')))])])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-raised-button', {
    staticClass: "yesterday-btn",
    attrs: {
      "icon": "refresh",
      "label": _vm.$t('message.foodDiaryRepeatYesterdayMeal'),
      "fullWidth": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.copyYesterdaysMeal.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), (_vm.recents.length > 0) ? _c('mu-col', {
    staticStyle: {
      "margin-top": "16px"
    },
    attrs: {
      "desktop": "100",
      "tablet": "100",
      "width": "100"
    }
  }, [_c('mu-card', [_c('mu-card-header', {
    attrs: {
      "title": _vm.$t('message.labelRecents')
    }
  }), _vm._v(" "), _c('mu-list', {
    attrs: {
      "id": "recents"
    }
  }, _vm._l((_vm.recents), function(item, index) {
    return _c('mu-list-item', {
      key: 'recent-' + index,
      attrs: {
        "title": item.food_name
      },
      nativeOn: {
        "click": function($event) {
          return _vm.selectRecent(item)
        }
      }
    }, [_c('mu-icon', {
      staticClass: "left8",
      attrs: {
        "slot": "left",
        "value": "history"
      },
      slot: "left"
    })], 1)
  }), 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-343640c6","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/FoodDiary/Landing/Landing.vue
// module id = 3119
// module chunks = 1